import { ColumnMapping, SpreadsheetMapping } from 'api'
import { SpreadsheetParseResult } from '../model'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

export interface ColumnMappingPanelProps<TColumnMapping extends ColumnMapping> {
  fieldName: keyof SpreadsheetMapping
  fieldTitle: string
  columnMapping: TColumnMapping
  parseResult: SpreadsheetParseResult
  onUpdate: (columnMapping: TColumnMapping, fieldName: keyof SpreadsheetMapping) => unknown
}

export const ColumnMappingPanel = styled.div`
  & > * {
    margin-bottom: 6px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${constants.CORE_PRIMARY_3};
    margin-bottom: 6px;
  }
`
